<template>
    <div class="btn btn-with-gallery-filter py-0" :class="{'btn-with-gallery-filter--active': searchOnlyWithPrivateGallery}">
        {{ translate.home.withGallery }}
        <PrivateGallerySearchIconComponent class="ml-3"></PrivateGallerySearchIconComponent>
    </div>
</template>

<script>
import PrivateGallerySearchIconComponent from "@/components/search/partials/icons/PrivateGallerySearchIconComponent.vue";

export default {
    computed: {
        ...mapState(['translate', 'extraContent']),
        searchOnlyWithPrivateGallery(){
            return _.get(this, 'extraContent.privateGallery')
        }
    },

    components: {PrivateGallerySearchIconComponent},
}
</script>
